import request from '@/utils/request'

// 获取资讯本列表
export function getConsulationBookList(params) {
  return request({
    url: '/enrollment/consultationBook/list',
    method: 'get',
    params: params
  });
}

// 看板统计数据
export function boardStatistics(params) {
  return request({
    url: '/enrollment/consultationBookBoard/statistics',
    method: 'get',
    params: params
  });
}

// 看板来源统计数据
export function boardSourceStatistics(params) {
  return request({
    url: '/enrollment/consultationBookBoard/sourceStatistics',
    method: 'get',
    params: params
  });
}

// 看板年级统计数据
export function boardGradeStatistics(params) {
  return request({
    url: '/enrollment/consultationBookBoard/gradeStatistics',
    method: 'get',
    params: params
  });
}

// 看板学校统计数据
export function boardSchoolStatistics(params) {
  return request({
    url: '/enrollment/consultationBookBoard/schoolStatistics',
    method: 'get',
    params: params
  });
}

// 看板已转化学校统计数据
export function boardBillSchoolStatistics(params) {
  return request({
    url: '/enrollment/consultationBookBoard/billSchoolStatistics',
    method: 'get',
    params: params
  });
}

// 看板已到访校区统计数据
export function boardVisitedSchoolStatistics(params) {
  return request({
    url: '/enrollment/consultationBookBoard/visitedSchoolStatistics',
    method: 'get',
    params: params
  });
}

// 看板已到访来源统计数据
export function boardVisitedSourceStatistics(params) {
  return request({
    url: '/enrollment/consultationBookBoard/visitedSourceStatistics',
    method: 'get',
    params: params
  });
}

// 看板科目统计数据
export function boardSubjectStatistics(params) {
  return request({
    url: '/enrollment/consultationBookBoard/subjectStatistics',
    method: 'get',
    params: params
  });
}

// 获取跟进人
export function getFollowUserList() {
  return request({
    url: '/wechatWork/consultationBook/getFollowUserList',
    method: 'get'
  });
}

// 获取统计信息
export function getStatistics() {
  return request({
    url: '/enrollment/consultationBook/statistics',
    method: 'get'
  });
}


// 变更跟进人
export function changeFollowUser(followUserId, consultationBookId) {
  return request({
    url: '/wechatWork/consultationBook/changeFollowUser/' + followUserId + '/' + consultationBookId,
    method: 'get'
  });
}

// 查询跟进记录
export function getConsultationRecords(consultationBookId) {
  return request({
    url: '/wechatWork/consultationBook/getConsultationRecords/' + consultationBookId,
    method: 'get'
  });
}

// 查询线索详情 
export function getConsultationBookDetail(consultationBookId) {
  return request({
    url: '/enrollment/consultationBook/' + consultationBookId,
    method: 'get'
  });
}

// 添加跟进记录
export function addConsultationRecord(params) {
  return request({
    url: '/wechatWork/consultationBook/addConsultationRecord',
    method: 'post',
    params: params
  });
}

// 添加咨询线索
export function addConsultationBook(data) {
  return request({
    url: '/enrollment/consultationBook',
    method: 'post',
    data: data
  });
}

// 修改咨询线索
export function updateConsultationBook(data) {
  return request({
    url: '/enrollment/consultationBook',
    method: 'put',
    data: data
  });
}

// 认领咨询线索
export function claim(data) {
  return request({
    url: '/enrollment/consultationBook/claim',
    method: 'post',
    data: data
  });
}

// 冲突线索写入系统跟进记录
export function conflictFollowRecord(data) {
  return request({
    url: '/enrollment/consultationBook/conflictFollowRecord',
    method: 'post',
    data: data
  });
}